export const apiUrl = {
  //apiUrl: 'http://localhost:4000',
  //apiUrl: 'https://preprod-crm.herokuapp.com' // PREPROD
  apiUrl: 'https://pegase-api.herokuapp.com',
};
